import { List, Record } from 'immutable';
import { PartyType } from './party-type';
import { Contact } from './contact';
import { VendorPaymentSummary } from './vendor-payment-summary';
import { RatePlanCode } from './rate-plan-code';
import { EventAgencyStatus } from '../../shared/models/event-agency-status.enum';
import { TaxResponse } from './TaxResponse';

const PartyRecord = Record({
  eventPartyId: 0,
  version: 0,
  createDate: null,
  modifiedDate: null,
  brand: null,
  chain: null,
  propertyId: null,
  agencyId: null,
  partyType: null,
  payorType: null,
  code: null,
  name: null,
  dbaName: null,
  countryCode: null,
  eventId: null,
  line1: null,
  line2: null,
  line3: null,
  city: null,
  state: null,
  postalCode: null,
  eventReferenceNumber: null,
  startDate: null,
  endDate: null,
  autoGeneratedCode: null,
  manuallyAdded: null,
  contact: new Contact(),
  subscriber: null,
  commissionRoomPercentage: null,
  commRetention: false,
  masterBillPaid: false,
  isExpanded: false,
  paymentSummary: new VendorPaymentSummary(),
  partyEventName: null,
  createdEvent: null,
  mergedEvent: null,
  ratePlanCodes: [],
  userRef01: null,
  userRef02: null,
  userRef03: null,
  userRef04: null,
  userRef05: null,
  taxResponseList: null,
  config: null,
  eventAgencyStatus: null,
  originalCode: null
});

export class Party extends PartyRecord {
  eventPartyId: number;
  version: number;
  createdDate: Date;
  modifiedDate: Date;
  brand: string;
  chain: string;
  propertyId: string;
  agencyId: string;
  partyType: PartyType;
  payorType: string;
  code: string;
  name: string;
  dbaName: string;
  countryCode: string;
  eventId: number;
  line1: string;
  line2: string;
  line3: string;
  city: string;
  state: string;
  postalCode: string;
  eventReferenceNumber: string;
  startDate: string;
  endDate: string;
  autoGeneratedCode: boolean;
  manuallyAdded: boolean;
  contact: Contact;
  subscriber: boolean;
  commissionRoomPercentage: number;
  commRetention: boolean;
  masterBillPaid: boolean;
  isExpanded: boolean;
  paymentSummary: VendorPaymentSummary;
  partyEventName: string;
  createdEvent: string;
  mergedEvent: string;
  ratePlanCodes: RatePlanCode[];
  userRef01: string;
  userRef02: string;
  userRef03: string;
  userRef04: string;
  userRef05: string;
  taxResponseList: List<TaxResponse>;
  config: any;
  eventAgencyStatus: EventAgencyStatus;
  originalCode: string;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/party.ts